import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Panel, Button, Message, Grid, Row, Col, Icon, IconButton } from 'rsuite'
import PeriodExpensesSubproject from './periodExpenses/PeriodExpensesSubproject'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import { doneLoading, startLoading } from '../../utils/loading'
import { sendSubmitReview } from '../../redux/actions/paymentSave'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import pathname from '../../constants/pathname'

export default function BudgetSubproject({
  schema,
  isEditable,
  isHidePeriodExpenses,
  isHideBudgetPlan,
  isCollapseAllTableRow,
  isEditableBudgetPlan,
  isShowBudgetSubmitButton,
  shouldGetSidebarAfterSaveBudgetPlan,
  projectVersionId,
  onClickConfirmBudget = () => {},
  disabledSendButton
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState()
  const [formSchema, setFormSchema] = useState(schema)
  const [isShowConfimBudgetModal, setIsShowConfimBudgetModal] = useState(false)
  const [isShowConfirmSubmit, setIsShowConfirmSubmit] = useState(false)
  const [isEditBudgetPlan, setIsEditBudgetPlan] = useState(false)
  const [currentTotalInstallment, setCurrentTotalInstallment] = useState()
  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    if (!isEditableBudgetPlan) {
      return
    }
    setIsEditBudgetPlan(
      !formSchema.projectBudgetPlan?.masterBudgetPlan?.value ||
        !formSchema.projectBudgetPlan?.subBudgetPlan?.value ||
        !formSchema.projectBudgetPlan?.masterBudgetValue?.value
    )

    if (formSchema.budget?.periodExpensesData && !isHidePeriodExpenses) {
      const total = formSchema.budget?.periodExpensesData.reduce((sum, cur) => sum + cur.cost, 0)
      setCurrentTotalInstallment(total)
    }
  }, [formSchema])

  const handleOnChangeBudget = (totalInstallment) => {
    setCurrentTotalInstallment(totalInstallment)
    setIsEditBudgetPlan(true)
  }

  const handleOnCompleteBudgetPlan = async () => {
    if (shouldGetSidebarAfterSaveBudgetPlan) {
      await dispatch(getSchemaSidebar(projectId))
    }
  }

  const handleConfirmBudget = () => {
    setIsShowConfimBudgetModal(true)
  }

  const handleOnConfirmBudgetModal = () => {
    setIsShowConfimBudgetModal(false)
    onClickConfirmBudget(setIsLoading, setIsError)
  }

  const handleOnConfirmSubmit = async () => {
    
    setIsLoading(true)
    startLoading()
    try {
      let response = await sendSubmitReview(null, projectId)
      if (response.successed) {
        return history.push(`${pathname.subProject.overviewSubProject}`)
      }else {
        notification.open('error', {
          title: response?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
      setIsShowConfirmSubmit(false)
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
      setIsShowConfirmSubmit(false)
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel header={formSchema.header} shaded collapsible bordered defaultExpanded>
        {/* <div style={{ marginBottom: 10 }}>
          <BudgetSummarySubproject
            header={formSchema.budget?.budgetSummaryHeader}
            budget={formSchema.budget?.budgetSummary}
            duration={formSchema.budget?.duration}
            projectBudgetPlan={formSchema.projectBudgetPlan}
          />
        </div> */}

        {!isHidePeriodExpenses && (
          <div style={{ marginBottom: 10 }}>
            <PeriodExpensesSubproject
              header={formSchema.budget?.periodExpensesHeader}
              data={formSchema.budget?.periodExpensesData}
              initialInstallment={formSchema.masterCategoryOfCost}
              initialData={formSchema.masterCategoryCost}
              endProjectDate={formSchema.budget?.projectEndDate}
              startProjectDate={formSchema.budget?.projectStartDate}
              isEditable={isEditable}
              isCollapseAllTableRow={isCollapseAllTableRow}
              projectVersionId={projectVersionId}
              onChangeBudget={handleOnChangeBudget}
              isAssociate={formSchema.isAssociate}
              disabledForm={formSchema.budget?.disabled}
              activityBudget={formSchema.budget?.activityBudget}
              isValidateBudget={formSchema.budget?.isValidateBudget}
            />
          </div>
        )}
        {/* {!isHideBudgetPlan && (
          <div>
            <BudgetPlan
              header={formSchema.projectBudgetPlan?.header}
              masterBudgetPlan={formSchema.projectBudgetPlan?.masterBudgetPlan}
              masterBudgetValue={formSchema.projectBudgetPlan?.masterBudgetValue}
              subBudgetPlan={formSchema.projectBudgetPlan?.subBudgetPlan}
              subBudgetValue={formSchema.projectBudgetPlan?.subBudgetValue}
              isEditable={isEditableBudgetPlan}
              isEdit={isEditBudgetPlan}
              setIsEdit={(_isEdit) => setIsEditBudgetPlan(_isEdit)}
              limitBudgetValue={currentTotalInstallment || formSchema.budget?.budgetSummary}
              onComplete={handleOnCompleteBudgetPlan}
            />
          </div>
        )} */}
        <Grid fluid>
          <Row>
            {!!formSchema.budget.alert && (
              <Col style={{ marginTop: 20, marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
                <Message showIcon type="warning" description={formSchema.budget.alert} />
              </Col>
            )}
            {!!isError && (
              <Col style={{ marginTop: 10 }} xs={24} sm={24} md={24} lg={24}>
                <Message
                  showIcon
                  type="error"
                  description={
                    'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                  }
                />
              </Col>
            )}
            {isShowBudgetSubmitButton && (
              <Col style={{ marginTop: 20, marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
                <Button
                  style={{ width: 160 }}
                  appearance="ghost"
                  onClick={handleConfirmBudget}
                  icon={<Icon appearance="ghost" icon="edit" />}
                >
                  {formSchema.budget?.buttionPeriodExpensesLabel}
                </Button>
              </Col>
            )}

            {disabledSendButton || isEditable && (
              <Col style={{ marginTop: 20, marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
                <IconButton
                  appearance="ghost"
                  icon={<Icon icon="send" className="bt-gost-icon-radius" />}
                  onClick={() => {
                    console.log('currentTotalInstallment', currentTotalInstallment)
                    if(currentTotalInstallment < formSchema.budget?.activityBudget){
                      notification.open('error', {
                        title: `จำนวนเงินรวม น้อยกว่างบประมาณ (ขาด ${parseFloat(formSchema.budget?.activityBudget-currentTotalInstallment).toFixed(2)} บาท) `,
                        duration: 5000,
                      })
                    }else {
                      setIsShowConfirmSubmit(true)
                    }
                  }}
                >
                  {'ส่งเสนออนุมัติ'}
                </IconButton>
              </Col>
            )}
            
          </Row>
        </Grid>
      </Panel>
      <ConfirmWidget
        title={'ยืนยันงบประมาณ'}
        show={isShowConfimBudgetModal}
        detail={`กรุณายืนยันงบประมาณ`}
        onCancle={() => setIsShowConfimBudgetModal(false)}
        onConfirm={handleOnConfirmBudgetModal}
      />
 
      <ConfirmWidget
        title={'ยืนยันการส่งเสนออนุมัติ'}
        show={isShowConfirmSubmit}
        detail={`กรุณายืนยันการส่งเสนออนุมัติ`}
        onCancle={() => setIsShowConfirmSubmit(false)}
        onConfirm={handleOnConfirmSubmit}
      />
    </>
  )
}
